import axios from 'axios'
import {useQuery} from 'react-query'

const API_URL = process.env.REACT_APP_API_URL

export const AI_ASSIGNMENT_FEATURE_QUERY_KEY = 'ai-assignment-feature-enabled'

type FeatureFlagResponse = {
  result?: {
    isFeatureEnabled?: boolean
    isEnabled?: boolean
  }
}
//deployment redo
type AiAssignmentFlags = {
  isFeatureEnabled: boolean
  isEnabled: boolean
}

const useAiAssignmentFlag = (
  select: (flags: AiAssignmentFlags) => boolean,
  enabled: boolean
): boolean => {
  const {data} = useQuery<AiAssignmentFlags, unknown, boolean>(
    AI_ASSIGNMENT_FEATURE_QUERY_KEY,
    async () => {
      const response = await axios.get<FeatureFlagResponse>(`${API_URL}/ai-assignment-settings`)
      return {
        isFeatureEnabled: response.data?.result?.isFeatureEnabled === true,
        isEnabled: response.data?.result?.isEnabled === true,
      }
    },
    {
      enabled,
      select,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  )

  return enabled && data === true
}

export const useAiAssignmentFeatureEnabled = (enabled: boolean = true): boolean =>
  useAiAssignmentFlag((flags) => flags.isFeatureEnabled, enabled)

export const useAiAssignmentAgentActive = (enabled: boolean = true): boolean =>
  useAiAssignmentFlag((flags) => flags.isFeatureEnabled && flags.isEnabled, enabled)
